module.exports = __webpack_public_path__ + "static/media/ab.3c497fe7.jpeg";